import { render, staticRenderFns } from "./download-zip-btn.vue?vue&type=template&id=610dc93b"
import script from "./download-zip-btn.vue?vue&type=script&lang=js"
export * from "./download-zip-btn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports